import { render, staticRenderFns } from "./AccordionList.vue?vue&type=template&id=bcfb58d0&scoped=true&"
import script from "./AccordionList.vue?vue&type=script&lang=js&"
export * from "./AccordionList.vue?vue&type=script&lang=js&"
import style0 from "./AccordionList.vue?vue&type=style&index=0&id=bcfb58d0&lang=sass&scoped=true&"
import style1 from "./AccordionList.vue?vue&type=style&index=1&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcfb58d0",
  null
  
)

export default component.exports